import Loading from 'components/LoadingComponent/LoadingComponent';
import { Root } from './Loader.styles';

export default function Loader() {
  return (
    <Root>
      <Loading
        label={'Loading -- This could take a minute while our Expert Assistant searches for a response...'}
        delay={0}
      />
    </Root>
  );
}
